import { render } from "./SellerItem.vue?vue&type=template&id=5f73704c&scoped=true"
import script from "./SellerItem.vue?vue&type=script&lang=js"
export * from "./SellerItem.vue?vue&type=script&lang=js"

import "./SellerItem.vue?vue&type=style&index=0&id=5f73704c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f73704c"]])

export default __exports__